import { Box, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { BrandLockup } from '../brand/BrandLogo';
import WhyPrivatePopover from './WhyPrivatePopover';
import GoogleIcon from './GoogleIcon';

// Pre-auth nav: brand lockup left, "Why private?" popover + Google ghost button
// right. The ghost button leads with the 4-color Google "G" so it reads as
// Google-account auth, and triggers the existing Clerk OAuth handler.
const LandingNav = ({ onSignIn, isLoaded }) => {
  const theme = useTheme();

  return (
    <Box
      component="nav"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        px: { xs: 2, sm: 3 },
        py: 2,
      }}
    >
      <BrandLockup markSize={42} fontSize={20} />

      <Box sx={{ display: 'flex', alignItems: 'center', gap: '22px' }}>
        {/* Below ~900px the nav collapses to logo + Google button (spec section 7). */}
        <Box sx={{ display: { xs: 'none', md: 'block' } }}>
          <WhyPrivatePopover />
        </Box>

        <Button
          onClick={onSignIn}
          disabled={!isLoaded}
          disableElevation
          variant="outlined"
          startIcon={<GoogleIcon size={16} />}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            fontSize: 14,
            color: theme.palette.text.primary,
            borderColor: theme.palette.borderStrong,
            borderRadius: '9px',
            px: '15px',
            py: '8px',
            '&:hover': { borderColor: theme.palette.text.dim, backgroundColor: 'transparent' },
          }}
        >
          Sign in with Google
        </Button>
      </Box>
    </Box>
  );
};

export default LandingNav;
